module.exports = __webpack_public_path__ + "assets/success.1ca697da.svg";